import React from 'react';
import { colors, typography, spacing } from '../../theme';

/**
 * Said when a Stats read failed, so a failure never looks like "nothing yet" (Codex's task 017
 * review, 21 October 2026). props: { what, onRetry }
 */
const LoadFailed = ({ what, onRetry }) => (
  <div role="alert" style={{
    backgroundColor: colors.surface1, border: `1px solid ${colors.border}`, borderRadius: '14px',
    padding: spacing.lg, textAlign: 'center', marginBottom: spacing.lg,
  }}>
    <div style={{ ...typography.body, color: colors.text, marginBottom: spacing.md }}>
      Couldn't load {what}. Check your connection and try again.
    </div>
    {onRetry && (
      <button type="button" onClick={onRetry} style={{
        minHeight: '44px', padding: '0 20px', borderRadius: '8px', border: `1px solid ${colors.border}`,
        background: 'transparent', color: colors.text, fontSize: '14px', fontWeight: 600, cursor: 'pointer',
      }}>
        Try again
      </button>
    )}
  </div>
);

export default LoadFailed;
